export const colors = {
  //Base
  background: "#F5F5F5",
  cardBackground: "#FFFFFF",
  primaryText: "#1A1A1A",
  secondaryText: "#6E6E6E",

  //Accent
  volvoBlue: "#003057",
  complementaryBlue: "#336699",

  //Status
  success: "#3A913F",
  error: "#B00020",
  warning: "#E6A700",
  info: "#007FA3",

  //Legacy
  legacy: {
    lightGray: "#f5f5f5",
    lighterGray: "#fafafa",
    mediumGray: "#ebebeb",
    darkGray: "#333333",
    blue: "#1976d2",
    lightBlue: "#1565c0",
  },
};

export const getStatusColor = (status: string): string => {
  switch (status?.toLowerCase()) {
    case "available":
    case "success":
    case "in":
      return colors.success;
    case "unavailable":
    case "error":
    case "out":
      return colors.error;
    case "warning":
    case "uncertain":
      return colors.warning;
    case "unknown":
      return colors.secondaryText;
    case "info":
      return colors.info;
    default:
      return colors.secondaryText;
  }
};
